import { cloneElement } from 'react';

import type { TextFieldProps } from '@mui/material';
import type { FC } from 'react';
import type { ControllerProps } from 'react-hook-form';

export interface MuiTextFieldAdapterProps
  extends Omit<TextFieldProps, 'children'>, Partial<Parameters<ControllerProps['render']>[0]>
{
  children: React.ReactElement<TextFieldProps>;
  isExposingTextField?: boolean;
}

export const MuiTextFieldAdapter: FC<MuiTextFieldAdapterProps> = ({
  children,
  field,
  fieldState,
  formState,
  isExposingTextField = true,
  helperText = isExposingTextField && ' ',
  ...props
}) =>
  cloneElement( children, {
    ...field,
    ...(field && field.value) ? { value: field.value?.toString() } : {},
    ...props,
    error: Boolean( fieldState?.error ),
    helperText: fieldState?.error?.message ?? helperText,
  } );
